import { cx } from "@emotion/css";
import { ReactNode } from "react";
import { getUserInfo } from "src/hooks/useUser";
import ProfileIcon from "src/images/Icons/newIcons/userProfile/account.svg";

interface AvatarProps {
  className?: string;
  avatarClassName?: string;
  avatarUrl?: string;
  onClick?: React.MouseEventHandler<HTMLElement> | null;
  Default?: ReactNode;
}

export const Avatar = ({
  className,
  avatarClassName,
  avatarUrl,
  onClick = null,
  Default = null,
}: AvatarProps) => {
  if (avatarUrl) {
    return (
      <div className={cx(className, "cursor-pointer")} onClick={onClick ?? undefined}>
        <img
          src={avatarUrl}
          alt="avatar"
          className={cx(
            avatarClassName,
            "cursor-pointer avatar avatar-square",
            {
              "avatar--hover": !!onClick,
            },
          )}
        />
      </div>
    );
  }

  return <>{Default}</>;
};

interface UserAvatarProps {
  onClick?: React.MouseEventHandler<HTMLElement> | null;
  className?: string;
  avatarClassName?: string;
  Default?: ReactNode;
}

export const UserAvatar = ({
  onClick = null,
  className,
  avatarClassName,
  Default = null,
}: UserAvatarProps) => {
  const userInfo = getUserInfo();

  return (
    <Avatar
      avatarUrl={userInfo?.avatarUrl}
      onClick={onClick}
      className={className}
      avatarClassName={cx(avatarClassName, "avatar-64")}
      Default={
        Default ? (
          Default
        ) : (
          <div
            className={cx(className, "cursor-pointer grey-square")}
            onClick={onClick ?? undefined}
          >
            <ProfileIcon className={cx("icon-super-big icon-primary")} />
          </div>
        )
      }
    />
  );
};
